import { Component, OnInit ,OnDestroy } from '@angular/core';
import { AlertService } from '../../servicios/alert.service';
import { loading_show, loading_hide } from '../../app.helpers';
import { Result } from '../../servicios/servers.service';
import { TipoServicioService } from '../../servicios/tiposervicio.service';
import { PersonaService } from '../../servicios/persona.service';
import { VehiculoService } from '../../servicios/vehiculo.service';
import swal from 'sweetalert2';
import { EmpresaService } from '../../servicios/empresa.service';
import { Router, ActivatedRoute,NavigationExtras } from '@angular/router';
declare var jQuery: any;

@Component({
    selector: 'vehiculos',
    templateUrl: 'vehiculos.template.html'
})

export class VehiculosComponent implements OnInit, OnDestroy {

    constructor(
        private personaService: PersonaService,
        private alertService: AlertService,
        private vehiculoService: VehiculoService,
        private empresaService: EmpresaService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
        
    }

    ngOnInit() {
        this.sub = this.route
        .queryParams
        .subscribe(params => {
          // Defaults to 0 if no query param provided.
          
          this.conductor = params|| null;
          if(this.conductor != undefined){
              this.vehiculo.placa = this.conductor.placa;
          }
        });
        this.getTipoVehiculos();
        
        this.getEmpresas();
        
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    public conductor  = null;
    public filter ="";
    public vehiculo = {idTipoVehiculo:"",
                        placa:"",
                        modelo:"",
                        marca:"",
                        fecha_soat:"",
                        fecha_tecnomecanica:""
                    };
    public vehiculos = [];
    public idEmpresa = -1;
    public tipoVehiculos = [];
    public empresas = [];
    public update = false;
    public sub:any;


    files: FileList;
    getVehiculos() {
        loading_show();
        //this.vehiculoService.getAll((data: any) => {
        this.vehiculoService.getByEmpresa(this.idEmpresa,(data: any) => {   
            loading_hide();
            if (data.isOk) {
                
                this.vehiculos = data.Content;
            }

        });
    }

    getEmpresas() {
        loading_show();
        this.empresaService.getAll((data: any) => {
            loading_hide();
            if (data.isOk) {
                
                this.empresas = data.Content;
                this.idEmpresa = this.empresas[0].id;
                this.getVehiculos();
            }

        });
    }

    getTipoVehiculos() {
        loading_show();
        this.vehiculoService.getTiposDeVehiculos((data: any) => {
            loading_hide();
            if (data.isOk) {
                
                this.tipoVehiculos = data.Content;
            }

        });
    }

    

    getFiles(event: any) {
        this.files = event.target.files;
        for (var i = 0, f; f = this.files[i]; i++) {
            if (!f.type.match('image.*')) {
                continue;
            }
            var reader = new FileReader();
            reader.onload = (function (theFile) {
                return function (e) {
                    document.getElementById("image").innerHTML = ['<img class="animated bounceIn" style="width:60%; margin-left:20%" src="', e.target.result, '" />'].join('');
                };
            })(f);
            reader.readAsDataURL(f);
        }
    }

    saveVehiculo() {
        //let formData: FormData = new FormData();

        /*if (!this.files) {
            this.alertService.warning('por favor cargar logo del empresa');
            return;
        }*/

        //formData.append('imagen', this.files[0]);


        var object = {
            'placa': this.vehiculo['placa'],
            'marca': this.vehiculo['marca'],
            'modelo': this.vehiculo['modelo'],
            'fecha_soat':this.vehiculo['fecha_soat'],
            'fecha_tecnomecanica':this.vehiculo['fecha_tecnomecanica'],
            'idTipoVehiculo':this.vehiculo['idTipoVehiculo']
        }

        //formData.append('empresa', JSON.stringify(object));

        loading_show();
        this.vehiculoService.save(object, (data: Result) => {
            loading_hide();

            if (data.isOk) {

                if(this.conductor == null){
                    
                    this.getVehiculos();
                    this.vehiculo = this.vehiculos[0];
                    this.alertService.success(data.Mensaje);

                }else{
                    
                    this.alertService.success(data.Mensaje);
                    let navigationExtras:  NavigationExtras;
                    navigationExtras= {
                        queryParams: this.conductor
                    };

                    this.router.navigate(['conductores'], navigationExtras);
                    
                }

                
            }else{

                this.alertService.error(data.Mensaje);

            }
        });

    }

    showvehiculo(vehiculo: any) {
        
        this.vehiculo = vehiculo;
        this.update = true;
        jQuery("#t1").addClass("active");
        jQuery("#t2").removeClass("active");
        jQuery("#tab-1").addClass("active");
        jQuery("#tab-2").removeClass("active");

    }


    cancel() {
        this.vehiculo = this.vehiculos[0];
        this.update = false;
        document.getElementById("image").innerHTML = '<div class="row">' +
            '<div class="col-lg-12" style="text-align: center;">' +
            '<i class="fa fa-image ico-bg"></i>' +
            '</div>' +
            '</div>';
    }

    updateVechiculo() {
       
        var object = {
            'id': this.vehiculo['id'],
            'placa': this.vehiculo['placa'],
            'marca': this.vehiculo['marca'],
            'modelo': this.vehiculo['modelo'],
            'fecha_soat':this.vehiculo['fecha_soat'],
            'fecha_tecnomecanica':this.vehiculo['fecha_tecnomecanica'],
            'idTipoVehiculo':this.vehiculo['idTipoVehiculo']
        }

        //formData.append('empresa', JSON.stringify(object));

        loading_show();
        this.vehiculoService.update(object, (data: Result) => {
            loading_hide();
            console.log(data)
            if (data.isOk) {
                this.update = false;
                this.vehiculo = {idTipoVehiculo:"",
                                    placa:"",
                                    modelo:"",
                                    marca:"",
                                    fecha_soat:"",
                                    fecha_tecnomecanica:""
                                };
                this.getVehiculos();
                //this.conductor = this.conductores[0];
                this.alertService.success(data.Mensaje);

            }
        });
    }


    updateState(id: number, state: string) {
        loading_show();
        var object = {
            'id': id,
            'estado': state
        }

        this.personaService.updateState(object, (data: Result) => {
            loading_hide();
            if (data.isOk) {
                this.alertService.success("Estado actualizado");
                //this.getConductores();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/views/vehiculos/vehiculos.component.ts